export default __webpack_public_path__ + "static/media/down.36f0c116.svg";